import { colors, screen } from 'components/styles/variables';
import css from 'styled-jsx/css';

export function srpTileStyles(isDesktop: boolean): ReactModal.Styles {
  return {
    content: {
      height: isDesktop ? 713 : '100%',
      width: isDesktop ? 570 : '100%',
      borderRadius: isDesktop ? 16 : '',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      overflowY: isDesktop ? 'hidden' : 'scroll',
      overflowX: 'hidden',
      padding: '20px 32px',
    },
    overlay: {
      zIndex: 1000,
      overflowY: isDesktop ? 'hidden' : 'scroll',
      overflowX: 'hidden',
      backgroundColor: 'rgba(0,0,0,.5)',
    },
  };
}

export const styles = css`
  /* Overview card styling */

  .border {
    border-top: 1px solid ${colors.G2};
    border-bottom: 0;
    padding: 0;
    position: fixed;
    left: -15px;
    width: calc(100% + 32px);
    top: 98px;
  }
  .overview-card {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 16px;
    gap: 16px;
    border: 1px solid #d3d3d3;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    margin-bottom: 24px;
    background: ${colors.WHITE};
    position: fixed;
    z-index: 10;
    position: relative;
    width: 100%;
    height: 108px;
    margin-top: 28px;
  }

  @media (max-width: ${screen.mobileMax}) {
    .overview-card {
      height: auto;
    }
  }

  .make-model,
  .price {
    color: ${colors.BLACK};
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.2px;
  }
  .favorite-button {
    position: relative !important;
    top: auto !important;
    right: auto !important;
  }
  .favorite-button button {
    width: 32px !important;
    height: 32px !important;
  }
  .favorite-button img {
    width: 17.5px;
    height: 16px;
  }
  .make-model {
    width: 100%;
  }
  .est-payment {
    color: ${colors.G3};
    font-weight: 400;
    margin-left: 6px;
    font-size: 14px;
  }
  .full-width {
    width: 100%;
  }
  .overview-image-container {
    width: 113px;
  }

  /* Vehicle Information section styling */

  .vehicle-information {
    border-top: 1px solid ${colors.G2};
    padding-top: 16px;
    margin-top: 16px;
  }
  .information-row {
    display: flex;
    justify-content: space-between;
  }

  @media (max-width: ${screen.mobileMax}) {
    .information-row {
      flex-direction: column;
    }
  }

  .information-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 200px;
    height: 32px;
  }

  @media (max-width: ${screen.mobileMax}) {
    .information-section {
      width: 100%;
    }
  }

  .information-title {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${colors.BLACK};
  }
  .information-content {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${colors.BLACK};
  }

  /* Key Details section styling */

  .detail-row {
    display: flex;
    justify-content: space-between;
  }
  .detail-section {
    display: flex;
    align-items: center;
    gap: 12px;
    height: 66px;
    width: 241px;
  }
  .detail-title {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
    margin-bottom: 1px;
    color: ${colors.BLACK};
  }
  .detail-content {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${colors.BLACK};
  }

  /* Section header styling */

  .section-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    align-items: center;
  }
  .section-title {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.2px;
    text-transform: uppercase;
  }
  .view-more {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${colors.ALR1};
  }
  .view-more:hover {
    cursor: pointer;
  }
  .view-more-arrow {
    margin-left: 6px;
  }

  /* Close button styling */

  .close-button {
    background: none;
    border: none;
    padding: 0;
    position: fixed;
    top: 12px;
    right: 16px;
    height: 15px;
  }
  .close-button img {
    height: 15px;
    width: 15px;
    position: relative;
  }

  /* HTML styling overrides */

  .section-title,
  .detail-title,
  .detail-content {
    margin: 0;
  }
  .detail-list {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
`;
